export const URL_BASE_API_DEV = "https://remc-api.damoreto.com/api/v1";